// extracted by mini-css-extract-plugin
export default {"List":"_399zLxRppxorilTPIloSN1"};